<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div class="row">
				<div class="col-3">
					<form class="ts-h-full">
						<fieldset class="ts-h-full">
							<legend>{{ $t('yearlyPaymentList.criteria') }}</legend>
							<div class="row form-group">
								<div class="col-md-12">
									<label class="required">{{
										$t('yearlyPaymentList.branchName')
									}}</label>
									<a-select style="width: 100%" v-model.number="model.branch_id" :options="branches"></a-select>
									<div class="validate" v-if="errors.has('branch_id')">
										{{ errors.first('branch_id') }}
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<label class="required">{{
										$t('yearlyPaymentList.acYear')
									}}</label>
									<a-select style="width: 100%" v-model.number="model.ac_year_id" :options="ac_year_list"
										@change="acYearChange"></a-select>
									<div class="validate" v-if="errors.has('ac_year_id')">
										{{ errors.first('ac_year_id') }}
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<label :class="!model.fee_type_id ? 'required' : ''">{{
										$t('yearlyPaymentList.subProgram')
									}}</label>
									<a-select style="width: 100%" :maxTagCount="1" v-model.number="model.acps_id" :options="sub_programs"
										:show-search="true" :filter-option="(input, option) =>
											option.componentOptions.children[0].text
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
											" @change="onSubChange" :disabled="!model.ac_year_id"></a-select>
									<div class="validate" v-if="errors.has('acps_id')">
										{{ errors.first('acps_id') }}
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<label :class="!model.fee_type_id ? 'required' : ''">{{
										$t('yearlyPaymentList.acTerm')
									}}</label>
									<a-select style="width: 100%" :maxTagCount="1" mode="multiple" v-model="model.ac_term_id"
										:options="ac_terms" :show-search="true" :filter-option="(input, option) =>
											option.componentOptions.children[0].text
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
											" @change="acTermChange"></a-select>
									<div class="validate" v-if="errors.has('ac_term_id')">
										{{ errors.first('ac_term_id') }}
									</div>
								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12">
									<div class="ts-flex ts-justify-between ts-text-right">
										<label :class="!model.fee_type_id ? 'required' : ''">{{
											$t('yearlyPaymentList.classOperation')
										}}</label>
										<ts-checkbox @change="selectAllClass">All</ts-checkbox>
									</div>
									<a-select style="width: 100%" :maxTagCount="1" v-model="model.class_id" :options="class_options"
										:show-search="true" :limit="1" mode="multiple" :filter-option="(input, option) =>
											option.componentOptions.children[0].text
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
											"></a-select>
									<div class="validate" v-if="errors.has('class_id')">
										{{ errors.first('class_id') }}
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 text-right">
									<ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting">{{
										$t('preview') }}</ts-button>
								</div>
							</div>
						</fieldset>
					</form>
				</div>
				<div class="col-md-9">
					<form>
						<fieldset>
							<legend>{{ $t('yearlyPaymentList.previewPdf') }}</legend>
							<ts-preview-pdf v-model="waiting" :src="src" />
						</fieldset>
					</form>
				</div>
			</div>
		</ts-loading-banner>
	</div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { join } from 'lodash'
import { mapActions } from 'vuex'

export default {
	name: 'yearlyPaymentListByClass',
	data() {
		return {
			loading: false,
			waiting: false,
			exporting: false,
			src: '',
			errors: new Errors(),
			sub_programs: [],
			ac_terms: [],
			ac_year_list: [],
			class_options: [],
			branches: [],
			model: {
				report_type: 'en',
				branch_id: null,
				acps_id: null,
				ac_term_id: [],
				ac_year_id: null,
				class_id: [],
				status: ['Active']
			}
		}
	},
	created() {
		this.fetchData()
	},
	computed: {
		status() {
			return this.$store.state.reportPayment.studentStatus
		},
		isRequiredClass() {
			return this.model.fee_setup_id.length == 0
		}
	},
	methods: {
		...mapActions('reportPayment', [
			'getBranch',
			'yearlyPaymentList',
			'getSubProgram',
			'getTerm',
			'getYear',
			'getStudentStatus',
			'getClass'
		]),
		async fetchData() {
			this.loading = true
			await this.getStudentStatus()
			await this.getBranch().then(response => {
				this.branches = response.data.map(el => ({
					value: el.branch_id,
					label: el.branch_name_en
				}))
				this.model.branch_id = this.$store.state.authUser.default_branch_id
			})
			await this.getSubProgram()
				.then(response => {
					this.sub_programs = response.data.map(el => ({
						value: el.acps_id,
						label: el.acps_name_foreign
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onBranchChange() {
			this.model.ac_year_id = null
			this.model.acps_id = []
			this.model.ac_term_id = []
			this.model.class_id = []
			this.model.fee_type_id = null
			this.model.fee_setup_id = []
			this.feeSetups = []
			this.fetching = true
			this.getYear({
				filter: {
					ac_status_id: '1,2,3',
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
						el => ({
							value: el.ac_year_id,
							label:
								el.ac_year +
								(el.ac_status_id == 1
									? ' ( Current ) '
									: el.ac_status_id == 2
										? ' ( History ) '
										: ' ( Next ) ')
						})
					)
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.fetching = false
				})
		},
		onSubChange(acps_id) {
			this.model.ac_term_id = []
			this.model.class_id = []
			this.loading = true
			this.getTerm({
				filter: {
					acps_id: acps_id,
					ac_status_id: '1,2,3',
					ac_year_id: this.model.ac_year_id,
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.ac_terms = _.sortBy(response.data, ['ac_status_id']).map(el => ({
						value: el.ac_term_id,
						label:
							el.term_name +
							(el.ac_status_id == 1
								? ' ( Current ) '
								: el.ac_status_id == 2
									? ' ( History ) '
									: '( Next )')
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		acYearChange() {
			this.model.acps_id = null
			this.model.ac_term_id = []
			this.model.class_id = []
		},
		acTermChange(ac_term_id) {
			this.loading = true
			this.getClass({
				filter: {
					ac_term_id: join(ac_term_id, ','),
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.class_options = response.data.map(el => ({
						value: el.class_id,
						label:
							el.class_name +
							' | ' +
							el.teacher.full_name_en +
							' | ' +
							el.academic_study_time.study_time
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		preview() {
			this.waiting = true
			this.src = ''
			this.errors = new Errors()
			this.yearlyPaymentList(this.model)
				.then(response => {
					this.src = response.url
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		selectAllClass(value) {
			if (value) {
				this.class_options.forEach(el => {
					this.model.class_id.push(el.value)
				})
			} else {
				this.model.class_id = []
			}
		}
	},
	watch: {
		'model.branch_id': function (val) {
			if (val) {
				this.onBranchChange()
			}
		}
	}
}
</script>
